import { get } from 'lodash'

export const RESOURCE_NOT_FOUND = 'RESOURCE_NOT_FOUND'

export const errorCoder = (error: any): string => {
  return get(error, 'graphQLErrors[0].extensions.code')
}
